import { render, staticRenderFns } from "./SponsoredRecommendationImageHomeGlobal.vue?vue&type=template&id=ac487470&scoped=true"
import script from "./SponsoredRecommendationImageHomeGlobal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationImageHomeGlobal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationImageHomeGlobal.vue?vue&type=style&index=0&id=ac487470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac487470",
  null
  
)

export default component.exports